import { Box, CollapsableCard, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import type { IntegrationsSyncableStateFieldsFragment } from 'generated/resources/graphql'
import { useToggle } from 'usehooks-ts'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { SyncStateLabel } from 'modules/integrations/public'

interface Props {
  syncableState: IntegrationsSyncableStateFieldsFragment
}

const formatDate = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

const SyncStatusCard = ({ syncableState }: Props) => {
  const status = syncableState.status
  const hasFailed = status === 'failed' || status === 'invalid'
  const [showContent, toggleContent] = useToggle(hasFailed)

  return (
    <CollapsableCard
      open={showContent}
      contentBackground="grey000White"
      contentPadding="s8"
      Card={
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="300" weight="semibold" color="radicalRed1200">
            {i18n.t('expenses_v2.alerts.integrations.expense_not_synced')}
          </Text>
          <Touchable onClick={toggleContent}>
            <Icon.Small icon={showContent ? 'chevron-up' : 'chevron-down'} color="grey800" />
          </Touchable>
        </Box>
      }
      Content={
        <Box gap="s8" paddingX="s8">
          <Box flexDirection="row" gap="s12" alignItems="center" flexWrap="wrap">
            <SyncStateLabel syncableState={syncableState} layout="noWrap" />
          </Box>
          {syncableState.statusUpdatedAt && (
            <Box flexDirection="row" gap="s6">
              <Text size="200" weight="medium">
                {i18n.t('integrations.footer.last_sync')}:
              </Text>
              <Text size="200" weight="medium" color="grey1000">
                {formatDate(syncableState.statusUpdatedAt)}
              </Text>
            </Box>
          )}
        </Box>
      }
    />
  )
}

export default SyncStatusCard
